import { createContext, useContext } from "react";

/**
 * Optional override for "is the leads 'Visits From' selection worldwide", consumed by the
 * International Visits filter to decide whether it is enabled.
 *
 * Defaults to `null`, in which case consumers fall back to the global leads-search-filters Redux
 * slice (the opportunity-list panel). Pages that drive the leads filters from local state — e.g.
 * the Teams filters tab — provide the value derived from their own draft instead. See ADR-0005
 * (module behaviour injection via React context).
 */
const VisitsFromWorldwideContext = createContext<boolean | null>(null);
VisitsFromWorldwideContext.displayName = "VisitsFromWorldwideContext";

export const VisitsFromWorldwideProvider = VisitsFromWorldwideContext.Provider;

export const useInjectedVisitsFromWorldwide = (): boolean | null => useContext(VisitsFromWorldwideContext);
